import { Col, Form, Row } from 'antd';
import React from 'react';

import { ERROR_MESSAGE } from '../../../utils/constants';
import FormItem from '../../Form/FormItem';
import Select from '../../Select';
import SubmitCancelButtonGroup from '../../SubmitCancelButtonGroup';
import HorizontalSwitch from '../../Switch/HorizontalSwitch';
import Text from '../../Text';
import TextInput from '../../TextInput';
import ReportTagSelect from '../ReportTagSelect';

const ReportForm = props => {
  const { t, isUpdate, disabled, loading, onFinish, onCancel, initialValues, ...rest } = props;
  const [form] = Form.useForm();

  const handleSubmit = async values => {
    await onFinish(values);

    if (!isUpdate) {
      form.resetFields();
    }
  };

  return (
    <Form
      {...rest}
      disabled={disabled}
      onFinish={handleSubmit}
      form={form}
      initialValues={{
        companyId: { required: false, keyName: null },
        groupId: { required: false, keyName: null },
        userId: { required: false, keyName: null },
        sendGroupIdAsString: false,
        ...initialValues,
      }}
    >
      <section>
        <FormItem
          name="name"
          label={t('name')}
          rules={[{ required: true, message: ERROR_MESSAGE().BLANK_FIELD }]}
        >
          <TextInput />
        </FormItem>

        <FormItem
          name="internalName"
          label={t('internalName')}
          rules={[{ required: true, message: ERROR_MESSAGE().BLANK_FIELD }]}
        >
          <TextInput />
        </FormItem>

        <FormItem name="visibleGlobally" valuePropName="checked">
          <HorizontalSwitch label={t('enabled')} size="medium" />
        </FormItem>

        <FormItem name="visibleOnReportsPage" valuePropName="checked">
          <HorizontalSwitch label={t('visibleOnReportsPage')} size="medium" />
        </FormItem>

        <FormItem
          name="sourceType"
          label={t('source')}
          rules={[
            {
              required: true,
              message: ERROR_MESSAGE().BLANK_FIELD,
            },
          ]}
        >
          <Select
            resetOnNoMatch={false}
            options={[
              { value: 'custom', label: 'Custom' },
              { value: 'metabase', label: 'Metabase' },
            ]}
          />
        </FormItem>

        <FormItem
          name="allowedRoles"
          rules={[
            {
              required: true,
              message: ERROR_MESSAGE().BLANK_FIELD,
              type: 'array',
            },
          ]}
          label={t('allowedRoles')}
        >
          <Select
            resetOnNoMatch={false}
            mode="multiple"
            options={[
              { value: 'company-admin', label: 'Company Admin' },
              { value: 'company-manager', label: 'Company Manager' },
            ]}
          />
        </FormItem>

        <FormItem name="tags" label={t('tags')}>
          <ReportTagSelect
            t={t}
            onChange={value => {
              form.setFieldsValue({
                tags: value,
              });
            }}
            value={form.getFieldValue('tags')}
          />
        </FormItem>

        <Text strong="true" style={{ marginBottom: 10 }}>
          {t('metabaseReportParams')}
        </Text>

        <FormItem label={t('metabaseReportId')} name="dashboardId">
          <TextInput placeholder={t('copyIdHere')} />
        </FormItem>

        <FormItem name="sendGroupIdAsString" valuePropName="checked">
          <HorizontalSwitch label={t('sendGroupIdAsString')} />
        </FormItem>

        <Row gutter={16}>
          {Object.entries({
            companyId: { label: t('companyId') },
            userId: { label: t('userId') },
            groupId: { label: t('groupId') },
          }).map(([field, { label }]) => (
            <Col span={24} key={field}>
              <Text strong="true">{label}</Text>
              <Row gutter={16} align="middle">
                <Col span={8} style={{ textAlign: 'center' }}>
                  <FormItem
                    name={[field, 'required']}
                    valuePropName="checked"
                    style={{ marginBottom: 0 }}
                  >
                    <HorizontalSwitch label={t('required')} />
                  </FormItem>
                </Col>
                <Col span={16} style={{ textAlign: 'center' }}>
                  <FormItem name={[field, 'keyName']} style={{ marginBottom: 0 }}>
                    <TextInput placeholder={t('keyName')} />
                  </FormItem>
                </Col>
              </Row>
              <div
                style={{
                  borderBottom: '1px solid #e8e8e8',
                  marginTop: 16,
                  marginBottom: 16,
                }}
              ></div>
            </Col>
          ))}
        </Row>
      </section>

      <SubmitCancelButtonGroup
        isForm
        onCancel={onCancel}
        disabled={disabled}
        loading={loading}
        submitText={t(isUpdate ? 'update' : 'create')}
      />
    </Form>
  );
};

export default ReportForm;
